"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TogglesLabel = exports.TogglesWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const TogglesWrapper = styled_components_1.default.div `
  position: relative;

  & > input {
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    z-index: 2;
    display: inline-flex;
    width: 100%;
    max-width: 30px;
    cursor: pointer;
    height: 100%;
  }

  &:hover label div,
  input.hover + label div {
    border-color: ${({ theme }) => theme.colors.greyBase};
  }

  input:checked + label > h4 {
    color: ${({ theme }) => theme.colors.greyBase};
  }

  input:checked + label > div > div {
    display: block;
    opacity: 1;
  }
`;
exports.TogglesWrapper = TogglesWrapper;
const TogglesLabel = styled_components_1.default.label `
  align-items: center;
  display: inline-flex;
  justify-content: center;

  & > h4 {
    color: ${({ theme }) => theme.colors.greyLighten40};
    padding: ${({ theme: { spacings } }) => `${spacings.xxs} ${spacings.xs}`};
  }

  & > h4:first-letter {
    text-transform: capitalize;
  }
`;
exports.TogglesLabel = TogglesLabel;
//# sourceMappingURL=toggles.js.map